// Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
import React from "react";
import { Button } from "@cloudscape-design/components";
import { useTranslation } from "react-i18next";
import { CSSProperties } from "react";

const EUCAuthButton = (): JSX.Element => {
  const { t } = useTranslation();

  const onClick = () => {
    window.location.href = `${window.location.origin}/authenticate`;
  };

  const spanStyle: CSSProperties = {
    display: "inline-block",
    width: "220px",
    textAlign: "center",
  };

  return (
    <Button
      data-testid={"euc-sign-in-button"}
      onClick={onClick}
      variant="primary"
    >
      <span style={spanStyle} id="span-text">
        {t("login.button.label")}
      </span>
    </Button>
  );
};

export default EUCAuthButton;
